import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import * as _clientser from "../../../../_redux/_services/ClientsSlice";
import * as _props from "../../../../_redux/_services/JobPostingSlice";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import { defaultPostingsData } from "../../../../_utilities/defaultfieldsModel";
import getUserDetails, {
  GetUserInfo,
  GetUserId,
} from "../../../../_utilities/getUserInfo";
import CkEditor from "../../../../components/CkEditor/CkEditor";
import { setBreadCrumb } from "../../../../_utilities/breadCrumb";
import { refreshOutlet } from "../../../../_redux/Uislice";

const initalState = { data: null, message: "", isloader: true };

const JobpostingDetailsEdit = ({
  jobDetailsID,
  input,
  iniValue,
  onReceiveProps,
}) => {
  const [getDetails, setGetDetails] = useState(iniValue);
  const [getDetailsRawData, setGetDetailsRawData] = useState("");
  const [isjobDesc, setIsjobDesc] = useState(false);
  const [isjobDescForSM, setIsjobDescForSM] = useState(false);
  const [clientNameObj, setClientNameObj] = useState({});
  const [managerObj, setManagerObj] = useState([]);
  const [teamLeadObj, setteamLeadObj] = useState([]);
  const [recruiterObj, setRecruiterObj] = useState([]);
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [recruitersObj, setRecruitersObj] = useState([]);
  const [systemRole, setSystemRole] = useState(false);
  const [listSegments, setListSegments] = useState([]);
  const [jobSegment, setJobSegment] = useState(null);
  const [isSegmentValue, setIsSegmentValue] = useState(false);
  const [jobDescValue, setJobDescValue] = useState("");
  const [jobDescforSMValue, setJobDescforSMValue] = useState("");
  const [userInfo, setUserInfo] = useState(null);
  const [primaryInput, setPrimaryInput] = useState("");
  const [secondaryInput, setSecondaryInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [locationValue, setLocationValue] = useState({
    id: 0,
    location: "",
    type: "",
  });

  // defaultDropdownOptionValues
  const [workModelValues, setWorkModelValues] = useState([]);
  const [jobStatusValues, setJobStatusValues] = useState([]);
  const [jobTypeValues, setJobTypeValues] = useState([]);
  const [priorityValues, setPriorityValues] = useState([]);

  // customFields
  const [customFieldsArray, setCustomFieldsArray] = useState([]);
  const [getcustomFields, setGetCustomFields] = useState(null);

  const clientVal = useSelector((state) => state.FilterClients.data);
  const teamleadList = useSelector(
    (state) => state.GetManagerTeamlead.teamLeads,
  );
  const managerList = useSelector((state) => state.GetManagerTeamlead.manager);
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const segmentList = useSelector((state) => state.GetListSegments.data);
  const updateCode = useSelector((state) => state.Editjobpostings.data);
  const endClientsData = useSelector((state) => state.GetEndClients.data);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (getDetails?.clientId) {
      dispatch(_clientser.getEndClientsAsync(getDetails.clientId));
    }
  }, [getDetails?.clientId, dispatch]);

  // Initialize locations
  const countriesData = useSelector((state) => state.CountriesListByValue.data);
  useEffect(() => {
    if (countriesData && countriesData.length > 0) {
      setLoading(false);
      setLocationsOptions(countriesData);
      dispatch(_ser.getCountriesListByValueStartReducer(initalState));
    } else if (countriesData && countriesData.length === 0) {
      setLocationsOptions([]);
      setLoading(false);
    }
  }, [countriesData]);

  const hasEndClient =
    !!getDetails?.clientId &&
    endClientsData?.endClients &&
    endClientsData.endClients.length > 0 &&
    endClientsData?.endClients?.filter((c) => c.status === 1).length > 0;

  useEffect(() => {
    defaultPostingsData.forEach((list) => {
      if (list.fieldName === "Work model") {
        setWorkModelValues(list.customValues);
      }
      if (list.fieldName === "JobStatus") {
        setJobStatusValues(list.customValues);
      }
      if (list.fieldName === "JobType") {
        setJobTypeValues(list.customValues);
      }
      if (list.fieldName === "priority") {
        setPriorityValues(list.customValues);
      }
    });
  }, []);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
      dispatch(_props.getManagerTeamleadAsync("team Lead", userId));
      dispatch(_props.getManagerTeamleadAsync("manager", userId));
      dispatch(_props.getManagerTeamleadAsync(" ", userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (teamleadList && teamleadList.length > 0) {
      const data = JSON.parse(JSON.stringify(teamleadList));
      setteamLeadObj(data);
    }
  }, [teamleadList]);

  useEffect(() => {
    if (managerList && managerList.length > 0) {
      const data = JSON.parse(JSON.stringify(managerList));
      setManagerObj(data);
    }
  }, [managerList]);

  useEffect(() => {
    if (recruiterList && recruiterList.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruiterObj(newArray);
    }
  }, [recruiterList]);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "1" && x.fieldType === "custom",
      );
      if (customPostingFieldsData.length > 0) {
        let Array = {};
        customPostingFieldsData.forEach((item) => {
          item.customValues =
            item.dataType.toLowerCase() !== "text box"
              ? JSON.parse(item.customValues)
              : "";
          item.moduleId = item.moduleId.toString();
          Array[item.fieldName] =
            item.dataType.toLowerCase() !== "text box" ? [] : "";
        });
        setCustomFieldsArray(customPostingFieldsData);
      }
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "1" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Work model") {
            setWorkModelValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Job status") {
            setJobStatusValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Job type") {
            setJobTypeValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Priority") {
            setPriorityValues(JSON.parse(list.customValues));
          }
        });
      }
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (segmentList && segmentList.length > 0) {
      const activeSegments = segmentList
        .filter((segment) => segment.segmentStatus === 1)
        .map(({ id, segmentName }) => ({ id: id, label: segmentName }));
      setListSegments([]); // clear old values
      setTimeout(() => {
        setListSegments(activeSegments);
      }, 0); // ensure fresh render
    }
  }, [segmentList]);

  useEffect(() => {
    let data = JSON.parse(JSON.stringify(getDetails));
    if (data && clientList.length > 0) {
      let clientValue = JSON.parse(JSON.stringify(clientList));
      let findClientIndex = clientValue?.findIndex(
        (x) => x.clientName === data.clientName,
      );
      if (findClientIndex !== -1) {
        data.clientName = clientValue[findClientIndex];
        data["clientId"] = clientValue[findClientIndex].id.toString();
        formik.values.clientId = clientValue[findClientIndex].id.toString();
        setClientNameObj(clientValue[findClientIndex]);
      }
    }
    if (data && recruiterObj.length > 0) {
      let filterObj = [];
      data?.recruiters?.forEach((id) => {
        let findIndex = recruiterObj?.findIndex((x) => x.id === id);
        if (findIndex !== -1) {
          filterObj.push(recruiterObj[findIndex]);
        }
      });
      setRecruitersObj(filterObj);
    }
  }, [clientList, recruiterObj, dispatch]);

  useEffect(() => {
    const init = async () => {
      if (clientVal && clientVal.length > 0) {
        let clientValue = JSON.parse(JSON.stringify(clientVal));
        let ClientData = [];
        clientValue.forEach((e) => {
          if (e.status === "Active") {
            e.clientName = e.clientName;
            ClientData.push(e);
          }
        });
        setClientList(ClientData);
      } else {
        const userInfo = await getUserDetails();
        if (userInfo) {
          dispatch(_clientser.filterClientsAsync(""));
        }
      }
    };
    init();
  }, [clientVal]);

  useEffect(() => {
    if (input) {
      const data = JSON.parse(JSON.stringify(input));
      // For non-"Create", check jobCode; for "Create" proceed
      if (data && data.jobCode !== "") {
        const stringJobType = data.jobType.toString();
        const listofjobType = stringJobType ? stringJobType.split(",") : [];
        let array = [];
        jobTypeValues.forEach((item) => {
          listofjobType.forEach((jobType) => {
            if (item?.toLowerCase() === jobType?.toLowerCase()) {
              array.push(item);
            }
          });
        });
        setSelectedJobTypes(array);
        formik.values.jobTitle = data.jobTitle;
        formik.values.externalSystemID = data.externalSystemID;
        formik.values.workModel = data.workModel;
        formik.values.jobStatus = data.jobStatus;
        formik.values.jobType = data.jobType.toString();
        formik.values.clientId = data.clientId;
        formik.values.clientBillRate = data.clientBillRate;
        formik.values.payBillRate = data.payBillRate;
        formik.values.location = data.location ? data.location : "";
        formik.values.locationDetails = data.locationDetails;
        formik.values.manager = data.manager;
        formik.values.teamLead = data.teamLead;
        formik.values.primarySkills = data.primarySkills;
        formik.values.segmentId = data.segmentId;
        formik.values.isClientConfidential = data.isClientConfidential;
        formik.values.endClientId = data.endClientId;
        formik.values.isEndClientConfidential = data.isEndClientConfidential;
        setIsSegmentValue(!!data.segmentId);

        // Parse and set custom fields
        const customFieldsData = data.customFields || [];
        if (customFieldsData.length > 0) {
          const formatCustomFields = {};
          customFieldsData.forEach(({ key, value }) => {
            formatCustomFields[key] = value;
          });
          setGetCustomFields(formatCustomFields);
        }
        const updatedValue = {
          id: 0,
          location: data.location || "",
          type: "",
        };
        setLocationValue(updatedValue);

        setGetDetails(data);
        setGetDetailsRawData(JSON.stringify(data));
        setJobDescValue(data.jobDesc);
        setJobDescforSMValue(data.jobDescForSM);

        if (segmentList?.length) {
          const jobSegment = segmentList.find((s) => s.id === data.segmentId);
          if (jobSegment) setJobSegment(jobSegment.segmentName);
        }
      }
    }
  }, [input, segmentList, jobTypeValues]);

  const onChangeHandler = (data, type) => {
    if (type === "jobDesc" || type === "jobDescForSM") {
      if (type === "jobDesc") {
        setJobDescValue(data);
        setIsjobDesc(data === " " ? true : false);
      } else if (type === "jobDescForSM") {
        setJobDescforSMValue(data);
        setIsjobDescForSM(data === " " ? true : false);
      }
      formik.values[type] = data;
    } else {
      let obj = JSON.parse(JSON.stringify(getDetails));
      if (type === "clientName") {
        obj["clientName"] = data;
      } else if (type === "clientId") {
        obj["endClientId"] = null;
        obj["isEndClientConfidential"] = 0;
        let filterData = clientList.filter(
          (x) => parseInt(x.id) === parseInt(data),
        );
        if (filterData.length > 0) {
          obj["clientName"] = filterData[0];
          obj["clientId"] = filterData[0].id;
          setClientNameObj(filterData[0]);
        } else {
          obj["clientName"] = {};
          setClientNameObj({});
        }
        obj["clientId"] = data !== undefined ? data : "";
        formik.values.clientId = data !== undefined ? data : "";
      } else if (type === "jobType") {
        obj[type] = data.toString();
        formik.values[type] = data.toString();
        setSelectedJobTypes(data);
      } else if (type === "recruiters") {
        let array = [];
        data.forEach((selected) => {
          let data = recruiterObj.filter((x) => x.id === selected);
          if (data.length > 0) {
            array.push(data[0]);
          }
        });
        setRecruitersObj(array);
        obj[type] = data;
      }
      if (type !== "jobType" && type !== "ClientID" && type !== "recruiters") {
        obj[type] = data;
        formik.values[type] = data;
      }
      setGetDetails(obj);
    }
  };

  const onChangeCustomFieldsHandler = (value, type) => {
    setGetCustomFields((prevousValue) => ({ ...prevousValue, [type]: value }));
  };

  const getValidationSchema = (listSegments = []) => {
    const shape = {
      jobTitle: Yup.string()
        .min(3, "Must be at least 3 characters") // fixed message
        .max(100, "Must be less than 100")
        .required("Please enter a job title"),
      externalSystemID: Yup.string()
        .nullable()
        .max(40, "Must be less than 40 characters"),
      workModel: Yup.string().required("Please select a work model"),
      jobStatus: Yup.string(),
      jobType: Yup.mixed().test(
        "jobType-required",
        "Please select a job type",
        (value) => {
          if (Array.isArray(value)) return value.length > 0;
          return !!value && value.toString().trim().length > 0;
        },
      ),
      clientBillRate: Yup.string(),
      payBillRate: Yup.string()
        .matches(
          /^[0-9]+[a-z]|[a-z]+[0-9]|[0-9]/,
          "Please provide a valid pay rate or salary",
        )
        .required("Please provide a valid pay rate or salary"),
      location: Yup.string().nullable().trim().required("Please enter a location"),
      jobDesc: Yup.string().required(
        "Job description is required. Please provide a description",
      ),
    };
    if (listSegments.length !== 0) {
      shape.segmentId = Yup.string()
        .nullable()
        .test(
          "required-when-segments-exist",
          "Please select a segment",
          function (value) {
            const { path, createError } = this;
            const isMatched = listSegments.some(
              (x) => x.id === value || String(x.id) === String(value),
            );
            if (!value || value === "0" || !isMatched) {
              if (getDetails?.segmentId) {
                delete getDetails.segmentId;
              }
              return createError({ path, message: "Please select a segment" });
            }
            return true;
          },
        );
    }
    return Yup.object(shape);
  };

  // Build errors for mandatory custom fields
  const validateMandatoryCustomFields = (fieldsArray = [], valuesObj = {}) => {
    valuesObj = valuesObj || {};
    const cfErrors = {};
    fieldsArray.forEach((f) => {
      if (Number(f.mandatory) !== 1) return; // only required
      const key = f.fieldName;
      const dt = (f.dataType || "").toLowerCase().trim();
      const v = valuesObj[key];

      if (dt === "text box") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "single select") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "multi select") {
        if (!Array.isArray(v) || v.length === 0)
          cfErrors[key] = "Select at least one option";
      }
    });
    return cfErrors;
  };

  const formik = useFormik({
    initialValues: iniValue,
    validationSchema: getValidationSchema(listSegments),
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validate: (values) => {
      const errors = {};
      // uses latest customFieldsArray + getcustomFields from this render
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length) {
        errors.customFields = cfErrors;
      }
      return errors;
    },

    onSubmit: async (values) => {
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length > 0) {
        formik.setErrors((prev) => ({
          ...(prev || {}),
          customFields: cfErrors,
        }));
        formik.setTouched(
          (prev) => ({
            ...(prev || {}),
            customFields: Object.fromEntries(
              Object.keys(cfErrors).map((k) => [k, true]),
            ),
          }),
          true,
        );
        return;
      }

      let ArrayOfCustomFields = [];
      if (getcustomFields !== null) {
        let keys = Object.keys(getcustomFields);
        keys.forEach((items, i) => {
          let obj = { key: items, value: getcustomFields[items] };
          ArrayOfCustomFields.push(obj);
        });
      }
      if (!isjobDesc && !isjobDescForSM) {
        values.clientName = getDetails.clientName
          ? getDetails.clientName
          : clientNameObj;
        values.customerId = getDetails.customerId;
        values.jobCode = getDetails.jobCode;
        values.externalSystemID = getDetails.externalSystemID;
        values.jobDesc = getDetails.jobDesc;
        values.jobDescForSM = getDetails.jobDescForSM;
        values.priority = getDetails.priority;
        values.segmentId = getDetails.segmentId;
        values.secondarySkills = getDetails.secondarySkills
          ? getDetails.secondarySkills.join(", ")
          : "";
        values.primarySkills = getDetails.primarySkills
          ? getDetails.primarySkills.join(", ")
          : "";
        values.userFirstName = getDetails.userFirstName;
        values.userId = getDetails.userId;
        values.userLastName = getDetails.userLastName;
        values["customFields"] = JSON.stringify(ArrayOfCustomFields);
        values["recruiters"] = JSON.stringify(getDetails.recruiters);
        values["jobDesc"] = jobDescValue;
        values["jobDescForSM"] = jobDescforSMValue;
        values["listofRecruitersemails"] = [];
        values["isClientConfidential"] = getDetails.isClientConfidential
          ? 1
          : 0;
        values["endClientId"] =
          hasEndClient && getDetails.endClientId ? getDetails.endClientId : null;
        values["isEndClientConfidential"] =
          hasEndClient && getDetails.isEndClientConfidential ? 1 : 0;
        values["locationDetails"] = getDetails.locationDetails;
        recruitersObj.forEach((item, index) => {
          let key = `recruitersemails[${index}]`;
          let obj = { [key]: { name: item.name, emailid: item.emailId } };
          values["listofRecruitersemails"].push(obj);
        });
        if(
          getDetailsRawData === JSON.stringify(getDetails) && 
          JSON.stringify(ArrayOfCustomFields) === JSON.stringify(getDetails.customFields) &&
          getDetailsRawData.jobDescForSM === jobDescforSMValue &&
          getDetailsRawData.jobDesc === jobDescValue
        ){
          onReceiveProps("loadApplicant");
          return;
        }
        await GetValidData(values);
      }
    },
  });

  const handleSaveClick = async (e) => {
    if (e) e.preventDefault();
    
    // Trigger Formik's built-in submit to show errors on UI
    formik.handleSubmit(e);

    // Validate manually to get the errors immediately
    const errors = await formik.validateForm();
    const errorKeys = Object.keys(errors);
    
    if (errorKeys.length > 0) {
      let firstErrorKey = errorKeys[0];
      
      if (firstErrorKey === "customFields" && errors.customFields) {
        const cfKeys = Object.keys(errors.customFields);
        if (cfKeys.length > 0) {
          firstErrorKey = cfKeys[0];
        }
      }
      
      // Allow React to re-render with error states before scrolling
      setTimeout(() => {
        let el = 
          document.getElementById(firstErrorKey) || 
          document.getElementById(`${firstErrorKey}-label`) || 
          document.getElementById(`${firstErrorKey}-select`) || 
          document.querySelector(`[name="${firstErrorKey}"]`) || 
          document.querySelector(`[name="${firstErrorKey}*"]`) || 
          document.querySelector(`[name="customFields.${firstErrorKey}"]`);

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (typeof el.focus === "function" && el.tabIndex !== undefined && el.tabIndex >= -1) {
            el.focus({ preventScroll: true });
          }
        }
      }, 100);
    }
  };

  const GetValidData = async (data) => {
    let Obj = JSON.parse(JSON.stringify(input));
    Obj.workModel = data.workModel;
    Obj.jobStatus = data.jobStatus;
    Obj.jobTitle = data.jobTitle;
    Obj.externalSystemID = data.externalSystemID;
    Obj.jobType = Array.isArray(data.jobType) ? data.jobType.join(",") : data.jobType;
    Obj.clientId = data.clientId;
    Obj.clientName = data.clientName.clientName;
    Obj.clientBillRate = data.clientBillRate;
    Obj.payBillRate = data.payBillRate;
    Obj.location = data.location;
    Obj.locationDetails = data.locationDetails;
    Obj.teamLead = data.teamLead;
    Obj.manager = data.manager;
    Obj.recruiters = data.recruiters;
    Obj.priority = data.priority;
    Obj.segmentId = data.segmentId;
    Obj.primarySkills = data.primarySkills;
    Obj.secondarySkills = data.secondarySkills;
    Obj.jobDesc = data.jobDesc;
    Obj.jobDescForSM = data.jobDescForSM;
    Obj.userId = data.userId;
    Obj.userFirstName = data.userFirstName;
    Obj.userLastName = data.userLastName;
    Obj.customerId = data.customerId;
    Obj.isClientConfidential = data.isClientConfidential;
    Obj.endClientId = data.endClientId || null;
    Obj.isEndClientConfidential = data.isEndClientConfidential || 0;
    Obj.customFields = data.customFields;
    Obj.updatedAt = data?.updatedAt;
    Obj.id = data?.id;
    Obj.jobCode = data?.jobCode;
    dispatch(_props.editjobpostingsAsync(jobDetailsID, Obj));
  };
  
  useEffect(() => {
    if (updateCode === 200) {
      dispatch(_props.editjobpostingsStartReducer(initalState));
      dispatch(_props.jobpostingsbyidStartReducer(initalState));
      let name = `${getDetails.jobTitle} (${getDetails.jobCode})`;
      setBreadCrumb(getDetails.id, name, 'Job Code');
      // dispatch(refreshOutlet());
      // let data = { limit: 9, offset: 1 };
      // dispatch(_props.listjobpostingsAsync(data, "list"));
      onReceiveProps("loadApplicant");
    }
  }, [updateCode, dispatch]);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserInfo();
      setUserInfo(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (userInfo) {
      let bool =
        userInfo[0].systemroles === "Manager" ||
        userInfo[0].systemroles === "Admin"
          ? true
          : false;
      setSystemRole(bool);
    }
  }, [userInfo]);

  const onRemoveHandler = (item, index, key) => {
    let details = { ...getDetails };
    details[key].splice(index, 1);
    setGetDetails(details);
  };

  return (
    <React.Fragment>
      <div className="actionBtnRtl" style={{ marginTop: "-80px" }}>
        <Button
          variant="text"
          className="buttonHover"
          style={{ color: "red", fontWeight: "bolder", width: "6rem" }}
          size="small"
          onClick={(e) => {
            e.preventDefault();
            onReceiveProps("loadApplicant");
          }}
        >
          <Link
            href="#"
            style={{ color: "red", fontSize: "14px" }}
            underline="always"
          >
            {" "}
            Cancel
          </Link>
        </Button>
        <Button
          variant="contained"
          className="buttonHover1"
          style={{
            backgroundColor: "var(--primary-bg-color)",
            color: "var(--primary-background-text-color)",
            borderRadius: "10px",
            fontSize: "14px",
            Height: "40px !important",
            width: "6rem",
          }}
          size="small"
          onClick={handleSaveClick}
        >
          Save{" "}
        </Button>
      </div>
      <div
        style={{
          width: "95.5%",
          border: "1px solid #E3E3E3",
          borderRadius: "16px",
          padding: "22px 30px",
          marginTop: "20px",
        }}
      >
        <h4 className="heading-style">Job Information</h4>
        <div
          style={{
            display: "flex",
            flexFlow: "wrap",
            marginBottom: "40px",
            marginTop: "10px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "18%" }}>
            <TextField
              className="boldlabel"
              error={
                formik.errors.jobTitle && formik.touched.jobTitle ? true : false
              }
              helperText={
                formik.errors.jobTitle && formik.touched.jobTitle
                  ? formik.errors.jobTitle
                  : ""
              }
              id="outlined-basic"
              variant="outlined"
              autoComplete="off"
              autoFocus={formik.errors.jobTitle !== "" ? true : false}
              label="Job Title*&nbsp;"
              style={{ width: "100%" }}
              name="jobTitle*"
              value={getDetails?.jobTitle}
              onChange={(e) =>
                onChangeHandler(e.target.value, "jobTitle", getDetails)
              }
              InputLabelProps={{
                shrink: true,
              }}
              onBlur={formik.handleBlur}
            />
          </div>
          <div style={{ width: "18%" }}>
            <TextField
              className="boldlabel"
              error={
                formik.errors.externalSystemID &&
                formik.touched.externalSystemID
                  ? true
                  : false
              }
              helperText={
                formik.errors.externalSystemID &&
                formik.touched.externalSystemID
                  ? formik.errors.externalSystemID
                  : ""
              }
              id="outlined-basic"
              variant="outlined"
              autoComplete="off"
              label="External Job ID&nbsp;"
              style={{ width: "100%" }}
              name="externalSystemID"
              value={getDetails.externalSystemID}
              onChange={(e) =>
                onChangeHandler(e.target.value, "externalSystemID", getDetails)
              }
              onBlur={formik.handleBlur}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div style={{ width: "18%" }}>
            <FormControl
              fullWidth
              autoComplete="off"
              error={
                formik.errors.jobStatus && formik.touched.jobStatus
                  ? true
                  : false
              }
            >
              <InputLabel className="boldSelectlabel">
                Job Status*&nbsp;
              </InputLabel>

              <Select
                value={getDetails.jobStatus}
                name="jobStatus"
                label="Job Status*"
                autoComplete="off"
                onChange={(e) =>
                  onChangeHandler(e.target.value, "jobStatus", getDetails)
                }
                onBlur={formik.handleBlur}
                style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
              >
                {jobStatusValues?.map((name) => (
                  <MenuItem className="selectOptions" key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {formik.errors.jobStatus && formik.touched.jobStatus
                  ? formik.errors.jobStatus
                  : ""}
              </FormHelperText>
            </FormControl>
          </div>
          <div style={{ width: "18%" }}>
            <FormControl
              sx={{ width: "100%" }}
              fullWidth
              error={
                formik.errors.jobType && formik.touched.jobType ? true : false
              }
            >
              <InputLabel
                className="boldSelectlabel"
                id="demo-multiple-chip-label"
                shrink={true}
              >
                Job Type*&nbsp;
              </InputLabel>
              <Select
                labelId="demo-multiple-chip-label"
                id=""
                multiple
                name="jobType"
                value={selectedJobTypes}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "jobType", getDetails)
                }
                onFocus={formik.handleBlur}
                input={
                  <OutlinedInput id="select-multiple-chip" label="Job Type*" />
                }
                renderValue={(selected) => {
                  let values = selected;
                  if (typeof values === "string") {
                    values = values.split(",");
                  }
                  const visibleItems = values.slice(0, 1);
                  const remainingCount = values.length - 1;
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        overflow: "hidden",
                      }}
                    >
                      {visibleItems.map((value) => (
                        <Chip key={value} label={value} size="small" />
                      ))}
                      {remainingCount > 0 && (
                        <Chip label={`+${remainingCount}`} size="small" />
                      )}
                    </Box>
                  );
                }}
              >
                {jobTypeValues?.map((name) => (
                  <MenuItem className="selectOptions" key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {formik.errors.jobType && formik.touched.jobType
                  ? formik.errors.jobType
                  : ""}
              </FormHelperText>
            </FormControl>
          </div>
          <div style={{ width: "18%" }}>
            <FormControl
              fullWidth
              autoComplete="off"
              error={
                formik.errors.workModel && formik.touched.workModel
                  ? true
                  : false
              }
            >
              <InputLabel className="boldSelectlabel" shrink={true}>
                Work Model*&nbsp;
              </InputLabel>
              <Select
                value={getDetails.workModel}
                name="workModel"
                autoComplete="off"
                label="Work Model*"
                onChange={(e) =>
                  onChangeHandler(e.target.value, "workModel", getDetails)
                }
                onBlur={formik.handleBlur}
                style={{
                  width: "100%",
                  height: "3.5rem",
                  borderRadius: "4px",
                }}
              >
                {workModelValues?.map((name) => (
                  <MenuItem className="selectOptions" key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {formik.errors.workModel && formik.touched.workModel
                  ? formik.errors.workModel
                  : ""}
              </FormHelperText>
            </FormControl>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "wrap",
            marginBottom: "25px",
            justifyContent: "space-between",
          }}
        >
          {userInfo?.[0]?.clientStatus === 1 && (
            <>
              <div style={{ width: "23%" }}>
                <div
                  className="boldlabel"
                  style={{ display: "flex", width: "100%" }}
                >
                  <Autocomplete
                    options={clientList?.length ? clientList : []}
                    className="clientsearch1"
                    autoHighlight
                    id="controlled-demo"
                    autoComplete="off"
                    clearOnEscape
                    value={
                      getDetails.clientName
                        ? getDetails.clientName
                        : clientNameObj
                          ? clientNameObj
                          : { id: "", clientName: "" }
                    }
                    style={{
                      width: "100%",
                      borderRadius: "120px",
                    }}
                    getOptionLabel={(option) =>
                      option?.clientName ? option?.clientName : ""
                    }
                    blurOnSelect={true}
                    onChange={(e, value) => {
                      onChangeHandler(
                        value?.id.toString(),
                        "clientId",
                        getDetails,
                      );
                    }}
                    sx={{ width: 503 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="boldlabel"
                        label="Client&nbsp;"
                        autoComplete="off"
                        error={
                          formik.errors.clientId && formik.touched.clientId
                            ? true
                            : false
                        }
                        onBlur={formik.handleBlur}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        helperText={
                          formik.errors.clientId && formik.touched.clientId
                            ? formik.errors.clientId
                            : ""
                        }
                      />
                    )}
                  />
                  <BsSearch
                    style={{ paddingTop: "1.2rem", marginLeft: "-2rem" }}
                  />
                </div>
                <span style={{ float: "initial" }}>
                  <FormControlLabel
                    style={{
                      backgroundColor: "inherit",
                    }}
                    control={
                      <Checkbox
                        checked={getDetails.isClientConfidential}
                        onChange={(e) =>
                          onChangeHandler(
                            e.target.checked,
                            "isClientConfidential",
                            getDetails,
                          )
                        }
                        name="isClientConfidential"
                        sx={{
                          color: "#fbc02d",
                          borderRadius: "4px",
                          "&.Mui-checked": {
                            color: "#fbc02d",
                          },
                          "&:not(.Mui-checked)": {
                            color: "#000000",
                          },
                        }}
                      />
                    }
                    label={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        Keep Client Confidential
                      </span>
                    }
                  />
                </span>
              </div>
              {hasEndClient && (
                <div style={{ width: "23%" }}>
                  <div
                    className="boldlabel"
                    style={{ display: "flex", width: "100%" }}
                  >
                    <Autocomplete
                      options={(endClientsData?.endClients || []).filter(
                        (c) => c.status === 1,
                      )}
                      autoHighlight
                      className="clientsearch1"
                      sx={{
                        width: 503,
                        "& .MuiAutocomplete-clearIndicator": {
                          display: "none",
                        },
                      }}
                      style={{
                        width: "100%",
                        borderRadius: "120px",
                      }}
                      disableClearable={false}
                      value={
                        endClientsData?.endClients?.find(
                          (x) =>
                            String(x.id) === String(getDetails.endClientId),
                        ) || null
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      onChange={(e, value) => {
                        onChangeHandler(
                          value?.id ? String(value.id) : null,
                          "endClientId",
                          getDetails,
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="End Client&nbsp;"
                          className="boldlabel"
                          onBlur={formik.handleBlur}
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                    <BsSearch
                      style={{ paddingTop: "1.2rem", marginLeft: "-2rem" }}
                    />
                  </div>

                  <span style={{ float: "initial" }}>
                    <FormControlLabel
                      style={{
                        backgroundColor: "inherit",
                        margin: 0,
                      }}
                      control={
                        <Checkbox
                          checked={
                            Boolean(getDetails.isEndClientConfidential) || false
                          }
                          onChange={(e) =>
                            onChangeHandler(
                              e.target.checked,
                              "isEndClientConfidential",
                              getDetails,
                            )
                          }
                          name="isEndClientConfidential"
                          sx={{
                            color: "#fbc02d",
                            borderRadius: "4px",
                            "&.Mui-checked": {
                              color: "#fbc02d",
                            },
                            "&:not(.Mui-checked)": {
                              color: "#000000",
                            },
                          }}
                        />
                      }
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "0.89rem",
                          }}
                        >
                          Keep End Client Confidential
                        </span>
                      }
                    />
                  </span>
                </div>
              )}
            </>
          )}
          <TextField
            className="boldlabel"
            autoComplete="off"
            error={
              formik.errors.clientBillRate && formik.touched.clientBillRate
                ? true
                : false
            }
            helperText={
              formik.errors.clientBillRate && formik.touched.clientBillRate
                ? formik.errors.clientBillRate
                : ""
            }
            id="outlined-basic"
            label="Client Bill Rate&nbsp;"
            variant="outlined"
            style={{ width: "23%" }}
            name="clientBillRate"
            value={getDetails.clientBillRate}
            onChange={(e) =>
              onChangeHandler(e.target.value, "clientBillRate", getDetails)
            }
            onBlur={formik.handleBlur}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            className="boldlabel"
            autoComplete="off"
            error={
              formik.errors.payBillRate && formik.touched.payBillRate
                ? true
                : false
            }
            helperText={
              formik.errors.payBillRate && formik.touched.payBillRate
                ? formik.errors.payBillRate
                : ""
            }
            id="outlined-basic"
            label="Pay rate/Salary*&nbsp;"
            variant="outlined"
            style={{ width: "23%" }}
            name="payBillRate"
            value={getDetails.payBillRate}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) =>
              onChangeHandler(e.target.value, "payBillRate", getDetails)
            }
            onBlur={formik.handleBlur}
          />
          {!hasEndClient && <div style={{ width: "23%" }}></div>}
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "wrap",
            // marginBottom: "30px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "23%" }}>
            <FormControl fullWidth>
              <InputLabel
                className="boldSelectlabel"
                shrink={true}
                sx={{
                  px: 0.5,
                }}
              >
                Location *
              </InputLabel>
              <Autocomplete
                freeSolo
                loading={loading}
                options={locationsOptions || []}
                value={locationValue}
                autoComplete
                autoHighlight
                selectOnFocus
                handleHomeEndKeys
                clearOnEscape
                blurOnSelect={false}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "56px",
                  },
                }}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : option.location || ""
                }
                isOptionEqualToValue={(option, value) =>
                  option.location === value.location
                }
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    const updatedValue = {
                      id: 0,
                      location: value ? value.trimStart() : "",
                      type: "",
                    };
                    setLocationValue(updatedValue);
                    if(!value){
                      setLocationsOptions([]);
                    }
                    formik.setFieldValue("location", updatedValue.location);

                    if (value.length > 2) {
                      setLoading(true);
                      setTimeout(() => {
                        dispatch(
                          _ser.getCountriesListByValueAsync(
                            value.toLowerCase(), "JP"
                          )
                        );
                      }, 300);
                    }
                  } else if(reason === "clear"){
                      setLocationValue({ id: 0, location: "", type: "" });
                      setLocationsOptions([]);
                  }
                }}
                onChange={(event, value) => {
                  const updatedValue = value
                    ? typeof value === "string"
                      ? {
                          id: 0,
                          location: value,
                          type: "",
                        }
                      : value
                    : {
                        id: 0,
                        location: "",
                        type: "",
                      };

                  setLocationValue(updatedValue);

                  formik.setFieldValue(
                    "location",
                    updatedValue.location
                  );

                  formik.setFieldTouched("location", true);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    className="boldlabel"
                    autoComplete="new-password"
                    onBlur={() =>
                      formik.setFieldTouched("location", true)
                    }
                    error={Boolean(formik.touched.location && formik.errors.location)}
                    helperText={
                      formik.touched.location &&
                      formik.errors.location
                        ? formik.errors.location
                        : ""
                    }
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? (
                            <CircularProgress size={20} />
                          ) : null}

                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </FormControl>
          </div>
          
          <TextField
            className="boldlabel"
            autoComplete="off"
            id="locationDetails"
            label="Location Details"
            variant="outlined"
            style={{ width: "23%" }}
            name="locationDetails"
            value={getDetails.locationDetails}
            multiline={true}
            rows={3}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) =>
              onChangeHandler(e.target.value, "locationDetails", getDetails)
            }
            onBlur={formik.handleBlur}
          />

          <div style={{ width: "23%" }}>
            <FormControl
              fullWidth
              error={
                formik.errors.manager && formik.touched.manager ? true : false
              }
            >
              <InputLabel
                className="boldSelectlabel"
                shrink={true}
                sx={{
                  px: 0.5,
                }}
              >
                Manager
              </InputLabel>
              <Autocomplete
                id="controlled-demo"
                options={managerObj}
                getOptionLabel={(option) => {
                  let fullName = option.firstName + " " + option.lastName;
                  return fullName ? fullName : "";
                }}
                value={
                  getDetails.manager
                    ? managerObj.find((x) => x.id === parseInt(getDetails.manager)) ||
                      null
                    : null
                }
                onChange={(e, value) =>
                  onChangeHandler(value?.id, "manager", getDetails)
                }
                renderInput={(params) => <TextField {...params} />}
              />
              <FormHelperText>
                {formik.errors.manager && formik.touched.manager
                  ? formik.errors.manager
                  : ""}
              </FormHelperText>
            </FormControl>
          </div>
          <div style={{ width: "23%" }}>
            <FormControl
              fullWidth
              error={
                formik.errors.teamLead && formik.touched.teamLead ? true : false
              }
            >
              <InputLabel
                className="boldSelectlabel"
                shrink={true}
                sx={{
                  px: 0.5,
                }}
              >
                Team Lead
              </InputLabel>
              <Autocomplete
                id="controlled-demo"
                options={teamLeadObj}
                getOptionLabel={(option) => {
                  let fullName = option.firstName + " " + option.lastName;
                  return fullName ? fullName : "";
                }}
                value={
                  getDetails.teamLead
                    ? teamLeadObj.find((x) => x.id === parseInt(getDetails.teamLead)) ||
                      null
                    : null
                }
                onChange={(e, newValue) =>
                  onChangeHandler(newValue?.id, "teamLead", getDetails)
                }
                renderInput={(params) => <TextField {...params} />}
              />
              <FormHelperText>
                {formik.errors.teamLead && formik.touched.teamLead
                  ? formik.errors.teamLead
                  : ""}
              </FormHelperText>
            </FormControl>
          </div>
        </div>
        <div
          id="customFields"
          style={{
            display: "flex",
            flexFlow: "wrap",
            gap: "0% 2.66%",
            alignItems: "baseline",
          }}
        >
          <div style={{ width: "23%" }}>
            <FormControl
              fullWidth
              error={
                formik.errors.recruiters && formik.touched.recruiters
                  ? true
                  : false
              }
            >
              <InputLabel
                className={
                  !systemRole ? "viewSectionboldSelectlabel" : "boldSelectlabel"
                }
                shrink={true}
                sx={{
                  px: 0.5,
                }}
              >
                Recruiter
              </InputLabel>
              <Select
                multiple
                disabled={!systemRole ? true : false}
                name="recruiters"
                value={getDetails.recruiters || []}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "recruiters", getDetails)
                }
                onBlur={formik.handleBlur}
                input={
                  <OutlinedInput
                    id="select-multiple-chip-recruiter"
                    label="Recruiter"
                  />
                }
                renderValue={(selected) => {
                  let values = selected;
                  if (typeof values === "string") {
                    values = values.split(",");
                  }
                  const visibleItems = values.slice(0, 1);
                  const remainingCount = values.length - 1;
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        overflow: "hidden",
                      }}
                    >
                      {visibleItems.map((id) => {
                        const recruiter = recruiterObj.find((r) => r.id === id);
                        return (
                          <Chip
                            key={id}
                            label={recruiter?.name || id}
                            size="small"
                          />
                        );
                      })}
                      {remainingCount > 0 && (
                        <Chip label={`+${remainingCount}`} size="small" />
                      )}
                    </Box>
                  );
                }}
              >
                {recruiterObj?.map((recruiter) => (
                  <MenuItem
                    className="selectOptions"
                    key={recruiter.id}
                    value={recruiter.id}
                  >
                    {recruiter.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ width: "23%", marginTop: "30px" }}>
            <FormControl fullWidth>
              <InputLabel className="boldSelectlabel" shrink={true}>
                Priority
              </InputLabel>
              <Select
                style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
                value={getDetails.priority}
                name="priority"
                autoComplete="off"
                label="Priority &nbsp;"
                onChange={(e) =>
                  onChangeHandler(e.target.value, "priority", getDetails)
                }
                onBlur={formik.handleBlur}
              >
                {priorityValues?.map((name) => (
                  <MenuItem className="selectOptions" key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {listSegments.length > 0 ? (
            <div style={{ width: "23%", marginTop: "30px" }}>
              <FormControl
                fullWidth
                error={
                  formik.touched.segmentId && Boolean(formik.errors.segmentId)
                }
                autoComplete="off"
              >
                <InputLabel
                  className={
                    isSegmentValue ? "boldSelectlabelview" : "boldSelectlabel"
                  }
                  shrink
                  sx={{
                    px: 0.5,
                  }}
                >
                  Select Segment*
                </InputLabel>

                <Autocomplete
                  key={listSegments.length}
                  id="segment"
                  options={listSegments}
                  autoHighlight={true}
                  disableClearable={false}
                  freeSolo={true}
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  getOptionKey={(option) => option.id}
                  getOptionLabel={(option) => option?.label || ""}
                  filterOptions={(options, { inputValue }) => {
                    const term = inputValue.trim().toLowerCase();
                    if (!term) return options;
                    return options.filter((o) =>
                      o.label.toLowerCase().includes(term),
                    );
                  }}
                  value={
                    getDetails.segmentId
                      ? listSegments.find(
                          (x) => x.id === getDetails.segmentId,
                        ) || null
                      : null
                  }
                  onChange={(e, value) => {
                    onChangeHandler(value?.id, "segmentId", getDetails);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="segmentId"
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.segmentId &&
                        Boolean(formik.errors.segmentId)
                      }
                    />
                  )}
                />
                <FormHelperText>
                  {formik.touched.segmentId && formik.errors.segmentId}
                </FormHelperText>
              </FormControl>
            </div>
          ) : (
            ""
          )}

          {/* customFields Ui render start here */}
          {customFieldsArray &&
            customFieldsArray.length > 0 &&
            customFieldsArray.map((data, index) => {
              const err = formik.errors?.customFields?.[data.fieldName];
              const touched = formik.touched?.customFields?.[data.fieldName];
              const hasError = Boolean(
                err && (touched || formik.submitCount > 0),
              );
              const isReq = Number(data.mandatory) === 1;

              if (data.dataType.toLowerCase().trim() === "text box") {
                return (
                  <div style={{ width: "23%", marginTop: "30px" }}>
                    <TextField
                      className="boldlabel"
                      id={data.fieldName}
                      variant="outlined"
                      autoComplete="off"
                      style={{ width: "100%" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label={`${data.fieldName}${Number(data.mandatory) === 1 ? " *" : ""}`}
                      error={hasError}
                      helperText={hasError ? err : ""}
                      name={`customFields.${data.fieldName}`}
                      value={getcustomFields?.[data.fieldName] ?? ""}
                      onChange={(e) =>
                        onChangeCustomFieldsHandler(
                          e.target.value,
                          data.fieldName,
                        )
                      }
                      onBlur={formik.handleBlur}
                    />
                  </div>
                );
              } else if (
                data.dataType.toLowerCase().trim() === "multi select"
              ) {
                return (
                  <div style={{ width: "23%", marginTop: "30px" }}>
                    <FormControl
                      sx={{ width: "100%" }}
                      fullWidth
                      error={hasError}
                      required={isReq}
                    >
                      <InputLabel
                        className="boldSelectlabel"
                        shrink={true}
                        id={`${data.fieldName}-label`}
                      >
                        {data.fieldName}
                      </InputLabel>
                      <Select
                        labelId={`${data.fieldName}-label`}
                        id={`${data.fieldName}-select`}
                        multiple
                        name={`customFields.${data.fieldName}`}
                        value={
                          Array.isArray(getcustomFields?.[data.fieldName])
                            ? getcustomFields[data.fieldName]
                            : []
                        }
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                        onBlur={formik.handleBlur}
                        input={
                          <OutlinedInput
                            id={`select-multiple-chip-${data.fieldName}`}
                            label={data.fieldName}
                          />
                        }
                        renderValue={(selected) => {
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                                maxHeight: "65px",
                                overflowX: "auto",
                              }}
                            >
                              {typeof selected !== "string" &&
                                selected.map((value) => (
                                  <Chip key={value} label={value} />
                                ))}
                            </Box>
                          );
                        }}
                      >
                        {data?.customValues &&
                          data.customValues.length > 0 &&
                          data.customValues.map((name) => (
                            <MenuItem
                              className="selectOptions"
                              key={name}
                              value={name}
                            >
                              {name}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>{hasError ? err : ""}</FormHelperText>
                    </FormControl>
                  </div>
                );
              } else if (
                data.dataType.toLowerCase().trim() === "single select"
              ) {
                return (
                  <div style={{ width: "23%", marginTop: "30px" }}>
                    <FormControl fullWidth error={hasError} required={isReq}>
                      <InputLabel
                        className="boldSelectlabel"
                        id={`${data.fieldName}-label`}
                        shrink={true}
                      >
                        {data.fieldName}
                      </InputLabel>
                      <Select
                        name={`customFields.${data.fieldName}`}
                        labelId={`${data.fieldName}-label`}
                        label={data.fieldName}
                        id={`${data.fieldName}-select`}
                        autoComplete="off"
                        value={getcustomFields?.[data.fieldName] ?? ""}
                        variant="outlined"
                        style={{
                          width: "100%",
                          height: "3.5rem",
                          borderRadius: "4px",
                        }}
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                        onBlur={formik.handleBlur}
                      >
                        {data?.customValues &&
                          data.customValues.length > 0 &&
                          data.customValues.map((name) => {
                            return <MenuItem value={name}>{name}</MenuItem>;
                          })}
                      </Select>
                      <FormHelperText>{hasError ? err : ""}</FormHelperText>
                    </FormControl>
                  </div>
                );
              }
            })}
        </div>
        {/* customFields Ui render end here */}
      </div>
      <div
        style={{
          width: "95.5%",
          border: "1px solid #E3E3E3",
          borderRadius: "16px",
          padding: "22px 30px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "0px",
          }}
        >
          <FormControl
            fullWidth
            error={
              formik.errors.jobDesc && formik.touched.jobDesc ? true : false
            }
          >
            <InputLabel
              style={{ marginLeft: "-13px!important" }}
              autoComplete="off"
              sx={{ fontSize: "18px", marginBottom: "28px" }}
              className={
                formik.errors.jobDesc && formik.touched.jobDesc
                  ? "text-danger headerLabel"
                  : "headerLabel"
              }
            >
              Job Description*
            </InputLabel>
            <div
              id="jobDesc"
              className={
                formik.errors.jobDesc && formik.touched.jobDesc
                  ? "brd-danger"
                  : ""
              }
            >
              <CkEditor
                data={jobDescValue && jobDescValue === "" ? " " : jobDescValue}
                error={
                  formik.errors.jobDesc && formik.touched.jobDesc ? true : false
                }
                name="jobDesc"
                autoComplete="off"
                onUpdatehandler={(update) =>
                  onChangeHandler(update.data, "jobDesc")
                }
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.errors.jobDesc && formik.touched.jobDesc ? (
              <FormHelperText className="text-danger">
                Please enter a job description
              </FormHelperText>
            ) : (
              ""
            )}
          </FormControl>
        </div>
      </div>
      <div className="applicant-details-section">
        <div
          className="additionalList"
          style={{
            width: "95.5%",
            border: "1px solid #E3E3E3",
            borderRadius: "16px",
            padding: "22px 30px",
            marginTop: "20px",
          }}
        >
          <h4
            style={{ marginBottom: "10px" }}
            className={
              formik.errors.primarySkills && formik.touched.primarySkills
                ? "heading-style"
                : "heading-style"
            }
          >
            Primary Skills
          </h4>
          <TextField
            variant="outlined"
            style={{ width: "100%" }}
            placeholder="Enter primary skill and press Enter"
            value={primaryInput}
            onChange={(e) => setPrimaryInput(e.target.value)}
            error={
              formik.errors.primarySkills && formik.touched.primarySkills
                ? true
                : false
            }
            helperText={
              formik.errors.primarySkills && formik.touched.primarySkills
                ? formik.errors.primarySkills
                : ""
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();

                const skill = primaryInput.trim();
                if (!skill) return;

                let details = { ...getDetails };

                if (!details.primarySkills) {
                  details.primarySkills = [];
                }
                details.primarySkills.push(skill);
                setGetDetails(details);
                setPrimaryInput("");
              }
            }}
          />
          {getDetails?.primarySkills &&
            getDetails?.primarySkills.length > 0 && (
              <ul>
                {getDetails?.primarySkills?.map((item, i) => (
                  <li key={i}>
                    {item}{" "}
                    <CloseIcon
                      onClick={() => onRemoveHandler(item, i, "primarySkills")}
                    />
                  </li>
                ))}
              </ul>
            )}
        </div>
        <div
          className="additionalList"
          style={{
            width: "95.5%",
            border: "1px solid #E3E3E3",
            borderRadius: "16px",
            padding: "22px 30px",
          }}
        >
          <h4 style={{ marginBottom: "10px" }} className="heading-style">
            Secondary Skills
          </h4>
          <TextField
            variant="outlined"
            style={{ width: "100%" }}
            placeholder="Enter secondary skill and press Enter"
            value={secondaryInput}
            onChange={(e) => setSecondaryInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                const skill = secondaryInput.trim();
                if (!skill) return;
                let details = { ...getDetails };
                if (!details.secondarySkills) {
                  details.secondarySkills = [];
                }
                details.secondarySkills.push(skill);
                setGetDetails(details);
                setSecondaryInput("");
              }
            }}
          />
          {getDetails?.secondarySkills &&
            getDetails?.secondarySkills.length > 0 && (
              <ul>
                {getDetails?.secondarySkills?.map((item, i) => (
                  <li key={i}>
                    {item}{" "}
                    <CloseIcon
                      onClick={() =>
                        onRemoveHandler(item, i, "secondarySkills")
                      }
                    />
                  </li>
                ))}
              </ul>
            )}
        </div>
      </div>
      <div
        style={{
          width: "95.5%",
          border: "1px solid #E3E3E3",
          borderRadius: "16px",
          padding: "22px 30px",
          marginTop: "20px",
        }}
      >
        <div style={{ width: "100%" }}>
          <FormControl fullWidth error={isjobDescForSM === true ? true : false}>
            <InputLabel
              autoComplete="off"
              className={
                isjobDescForSM === true ? " headerLabel" : "headerLabel"
              }
              sx={{ fontSize: "18px", marginBottom: "28px" }}
            >
              Job Description For Social Media
            </InputLabel>
            <div id="jobDescForSMnew" onKeyDown={formik.handleBlur}>
              <CkEditor
                data={
                  jobDescforSMValue && jobDescforSMValue === ""
                    ? " "
                    : jobDescforSMValue
                }
                name="jobDescForSMnew"
                autoComplete="off"
                onUpdatehandler={(update) => {
                  onChangeHandler(update.data, "jobDescForSM");
                }}
              />
            </div>
          </FormControl>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(JobpostingDetailsEdit);
